import type { Tutorial } from '../../shared/types.js';

export const mcpServersTutorial: Tutorial = {
  name: 'mcp-servers',
  title: 'Get to know MCP Servers',
  description:
    'A quick tour of how external MCP servers give your agents extra tools, where they live, and how to add one.',
  category: 'mcp-servers',
  docPages: ['concepts/plugins'],
  agenda: ['What MCP servers do', 'Browse your configured servers', 'Add a server'],
  steps: [
    {
      id: 'intro',
      kind: 'info',
      title: 'What MCP servers do',
      body: 'MCP (Model Context Protocol) Servers expose external tools that agents can call. This includes GitHub, Slack, and your own MCP-enabled services. Connect an MCP Server here and any agent can use it.',
      path: '/configure/connect/mcp/servers',
    },
    {
      id: 'how-it-works',
      kind: 'info',
      title: 'How it works',
      body: 'Servers come in two flavors: Remote servers route through Runloop\u2019s MCP Hub, and Local servers are wired straight into the agent on its devbox, as a subprocess or a direct URL. Expand "How MCP servers work" anytime for the details.',
      target: '[data-tutorial-id="mcp-header"]',
      placement: 'bottom',
    },
    {
      id: 'list',
      kind: 'info',
      title: 'Your configured servers',
      body: 'Every server you add shows up here. From each row you can enable or disable it, edit its settings, or remove it.',
      target: '[data-tutorial-id="mcp-server-list"]',
      placement: 'top',
    },
    {
      id: 'add',
      kind: 'info',
      title: 'Add a server',
      body: 'The "Add MCP Server" button opens a form where you register a remote or local server. Once added, you can attach it when launching an agent.',
      target: '[data-tutorial-id="mcp-add-server"]',
      placement: 'left',
    },
    {
      id: 'done',
      kind: 'info',
      title: "That's the tour",
      body: 'You know where MCP servers live and what they are for. Want to add one now? We can walk through the form together.',
    },
  ],
  handoff: { tutorialName: 'add-mcp-server', label: 'Add an MCP server' },
};
